// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3309":"96c850d3a0061d00","7846":"776650b23105a87d","8827":"c4c4dd6a57a2b702"}[chunkId] + ".css";
};